// this is just an alias
module.exports = require('./fromAngleRadians')
